module.exports = __webpack_public_path__ + "img/discover.db86829f.png";